import DoubleArrowIcon from '@mui/icons-material/DoubleArrow';
import {
  Button,
  Grid,
  Link,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { Box, Container } from '@mui/system';

import DynamicBreadcrumbs from '@/components/nav/Breadcrumb';
import ResourcesRightSidebar from '@/components/nav/ResourcesRightSidebar';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';

const Form1120SchK1 = () => {
  return (
    <AppLayout
      meta={
        <Meta
          title="IRS Schedule K‑1: Shareholder Income & Credits"
          description="Track shareholder income, deductions, and credits with IRS Schedule K-1 (Form 1120-S). Discover filing rules and deadlines for S corporations at TaxZerone"
          keywords=""
          canonical="resources/business-tax/schedule-k-1/"
          ogType="article"
          jsonLdPricing="179.99"
          jsonLdAggregateRatingValue="4.97"
          jsonLdAggregateRatingCount="1658"
        />
      }
    >
      <Container maxWidth="lg" sx={{ textAlign: 'center' }}>
        <Typography
          variant="h1"
          sx={{
            fontSize: { lg: 40, md: 36, sm: 32, xs: 24 },
            fontWeight: 600,
            mb: 5,
            mt: 5,
            textAlign: 'center',
          }}
        >
          IRS{' '}
          <span className="highlight-container">
            <span className="highlight">Schedule K-1</span>
          </span>{' '}
          (Form 1120-S): Shareholder’s Income, Deductions & Credits
        </Typography>
        {/* <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            mt: 1,
            mb: 2,
          }}
        >
          E-File your IRS <span style={{ fontWeight: 600 }}> Form 1120-S</span>{' '}
          for the 2024 tax year by{' '}
          <span style={{ fontWeight: 600 }}>March 17, 2025,</span> to meet
          federal S
          <Hidden smDown>
            {' '}
            <br />
          </Hidden>{' '}
          corporation filing deadlines and avoid potential penalties.
        </Typography>
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Button
            variant="contained"
            className="btn-primary medium"
            sx={{
              fontSize: {
                xs: '16px !important',
                sm: '18px !important',
                lg: '24px !important',
              },
              transition: 'all 0.3s ease 0s',
              '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
            }}
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=1120sduedates`}
          >
            E-file Now!
          </Button> */}
        {/* </Box> */}
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          py: 5,
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        mt={0}
      >
        <Container maxWidth="lg" sx={{ mb: 0 }}>
          <DynamicBreadcrumbs />
          <Grid
            container
            spacing={0}
            rowSpacing={0}
            m={0}
            sx={{ flexDirection: 'row-reverse' }}
          >
            <Grid
              size={{ xs: 12, md: 3.5, sm: 4.5 }}
              sx={{ display: { xs: 'none', sm: 'block' } }}
            >
              <ResourcesRightSidebar />
            </Grid>
            <Grid size={{ xs: 12, md: 8.5, sm: 7.5 }}>
              <Paper
                variant="outlined"
                sx={{
                  border: '1px solid #ccc',
                  p: 3,
                  px: 3,
                  textAlign: 'left',
                  mb: 0,
                  minHeight: '100%',
                }}
              >
                <Box
                  component="article"
                  itemScope
                  itemType="https://schema.org/Article"
                  sx={{
                    p: 3,
                    px: 3,
                    backgroundColor: '#f0f5f8',
                    borderLeft: '5px solid #01456c',
                    mb: 4,
                    borderRadius: 3,
                    position: 'relative',
                  }}
                >
                  <link
                    itemProp="mainEntityOfPage"
                    href="https://www.taxzerone.com/resources/business-tax/schedule-k-1/"
                  />
                  {/* Article requires an image */}
                  <div
                    itemProp="image"
                    itemScope
                    itemType="https://schema.org/ImageObject"
                    style={{ display: 'none' }}
                  >
                    <link
                      itemProp="url"
                      href="https://www.taxzerone.com/assets/images/logo.webp"
                    />
                    <data itemProp="width" value="380" />
                    <data itemProp="height" value="124" />
                  </div>
                  <Box
                    sx={{
                      display: 'grid',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                      textAlign: 'left',
                      mb: 2,
                    }}
                  >
                    <Typography variant="body2">
                      Last updated:{' '}
                      <time
                        itemProp="datePublished"
                        dateTime="2026-08-25T09:00:00-05:00"
                      >
                        Aug 25, 2026
                      </time>
                      <time
                        itemProp="dateModified"
                        dateTime="2026-08-25T09:00:00-05:00"
                        style={{ display: 'none' }}
                      >
                        Aug 25, 2026
                      </time>
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ fontWeight: 600 }}
                      itemProp="author"
                      itemScope
                      itemType="https://schema.org/Person"
                    >
                      -by{' '}
                      <span itemProp="name">
                        <a
                          itemProp="url"
                          href={`${process.env.NEXT_PUBLIC_HOMESITE_URL}`}
                          style={{
                            color: 'inherit',
                            textDecoration: 'none',
                          }}
                        >
                          Nikhil Chowdary
                        </a>
                      </span>{' '}
                      | TaxZerone
                    </Typography>
                  </Box>
                  <Typography
                    component="h2"
                    itemProp="headline"
                    variant="h4"
                    sx={{
                      fontWeight: 600,
                      mb: 0.8,
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      color: '#01456c',
                      fontStyle: 'italic',
                    }}
                  >
                    Schedule K-1 (Form 1120-S) at a glance
                  </Typography>

                  <Box
                    component="ul"
                    itemScope
                    itemType="https://schema.org/ItemList"
                    sx={{
                      mb: 0,
                      pl: 0,
                      listStyle: 'none',
                      '& li': { mb: 1.6, position: 'relative', pl: 3 },
                      '& li::before': {
                        content: '"★"',
                        position: 'absolute',
                        left: 0,
                        top: '-2px',
                        color: '#01456c',
                        fontSize: '18px',
                      },
                    }}
                  >
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="1" />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Understand the purpose of Schedule K-1 (Form 1120-S)
                        </strong>{' '}
                        and how S corporations use it to report each
                        shareholder’s share of income, deductions, credits,
                        losses, and other tax items.
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="2" />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Learn who must prepare and receive Schedule K-1
                        </strong>{' '}
                        and how every S corporation filing Form 1120-S must
                        issue a separate Schedule K-1 to each shareholder and
                        submit it with the corporate return.
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="3" />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Explore how to complete Schedule K-1 step by step,
                        </strong>{' '}
                        including corporation details, shareholder information,
                        ownership percentages, and the reporting of income,
                        deductions, credits, and basis adjustments.
                      </span>
                    </li>
                    <li
                      itemProp="itemListElement"
                      itemScope
                      itemType="https://schema.org/ListItem"
                    >
                      <meta itemProp="position" content="4" />
                      <span itemProp="name">
                        <strong style={{ fontWeight: 600 }}>
                          {' '}
                          Understand the relationship between Schedule K and
                          Schedule K-1
                        </strong>{' '}
                        and how corporate totals are allocated to individual
                        shareholders for accurate pass-through tax reporting.
                      </span>
                    </li>
                  </Box>
                </Box>
                <Stack
                  direction={{ xs: 'column-reverse', md: 'row' }}
                  spacing={{ xs: 1, sm: 2, md: 3 }}
                  sx={{ mb: 0 }}
                >
                  <Box>
                    <Typography variant="body1" sx={{ mb: 1 }}>
                      Schedule K-1 (Form 1120-S) is used by S corporations to
                      report each shareholder’s share of income, deductions,
                      credits, and other tax items from the corporation. Whether
                      you are{' '}
                      <Link
                        href="/business-tax/efile-irs-form-1120-s/"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        filing Form 1120-S
                      </Link>{' '}
                      for the first time or managing multiple shareholders, this
                      guide helps you prepare Schedule K-1 accurately and stay
                      compliant with IRS requirements.
                    </Typography>
                  </Box>
                  <Box
                    sx={{ mb: 1, textAlign: { xs: 'center', md: 'left' } }}
                  />
                </Stack>
                <Box
                  sx={{
                    pt: 0,
                  }}
                >
                  <Typography variant="body1" sx={{ mb: 0.5 }}>
                    <b>Table of Contents</b>
                  </Typography>
                  <List
                    sx={{ mb: 5, border: '1px solid #ccc', borderRadius: 2 }}
                  >
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whatis" sx={{ color: '#0202ff' }}>
                          What is IRS Schedule K-1 (Form 1120-S)?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whyseck1" sx={{ color: '#0202ff' }}>
                          Why Schedule K-1 Matters
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#whomust" sx={{ color: '#0202ff' }}>
                          Who Must File Schedule K-1?
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#key" sx={{ color: '#0202ff' }}>
                          Key Relationship Between Schedules K & K-1
                        </Link>
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#filing" sx={{ color: '#0202ff' }}>
                          Filing Deadlines
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#hwoto" sx={{ color: '#0202ff' }}>
                          How to Complete Schedule K-1 (Form 1120-S)
                        </Link>
                        <List sx={{ pb: 0 }}>
                          <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                            <ListItemIcon
                              sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                            >
                              <DoubleArrowIcon />
                            </ListItemIcon>
                            <ListItemText>
                              <Link href="#part1" sx={{ color: '#0202ff' }}>
                                Part I: Information About the Corporation
                              </Link>
                            </ListItemText>
                          </ListItem>
                          <ListItem
                            sx={{ py: 0.5, pb: 0, alignItems: 'flex-start' }}
                          >
                            <ListItemIcon
                              sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                            >
                              <DoubleArrowIcon />
                            </ListItemIcon>
                            <ListItemText>
                              <Link href="#part2" sx={{ color: '#0202ff' }}>
                                Part II: Information About the Shareholder
                              </Link>
                            </ListItemText>
                          </ListItem>
                          <ListItem
                            sx={{ py: 0.5, pb: 0, alignItems: 'flex-start' }}
                          >
                            <ListItemIcon
                              sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                            >
                              <DoubleArrowIcon />
                            </ListItemIcon>
                            <ListItemText>
                              <Link href="#part3" sx={{ color: '#0202ff' }}>
                                Part III: Shareholder’s Share of Income,
                                Deductions, Credits, and Other Items
                              </Link>
                            </ListItemText>
                          </ListItem>
                        </List>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#common" sx={{ color: '#0202ff' }}>
                          Common Mistakes to Avoid
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#best" sx={{ color: '#0202ff' }}>
                          Best Practices for Compliance
                        </Link>
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ py: 0.5, alignItems: 'flex-start' }}>
                      <ListItemIcon
                        sx={{ minWidth: 'inherit', mr: 1, mt: 0.6 }}
                      >
                        <DoubleArrowIcon />
                      </ListItemIcon>
                      <ListItemText>
                        <Link href="#faqs" sx={{ color: '#0202ff' }}>
                          Frequently Asked Questions (FAQs)
                        </Link>
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 2,
                    scrollMarginTop: 83,
                  }}
                  id="whatis"
                >
                  What is IRS Schedule K-1 (Form 1120-S)?
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  <span style={{ fontWeight: 600 }}>
                    Schedule K-1 (Form 1120-S)
                  </span>{' '}
                  is a tax document issued by an{' '}
                  <span style={{ fontWeight: 600 }}>S corporation</span> to its
                  shareholders. It reports each shareholder’s share of the
                  corporation’s income, losses, deductions, and credits for the
                  year.
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  The IRS uses Schedule K-1 to ensure the income reported by the
                  corporation aligns with what shareholders report individually
                  on their{' '}
                  <Link
                    href="https://www.irs.gov/pub/irs-pdf/f1040.pdf"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 1040
                  </Link>
                  .
                </Typography>
                <Typography variant="body1" sx={{ mb: 4 }}>
                  Learn more about how S corporations file their main return
                  using{' '}
                  <Link
                    href="/business-tax/efile-irs-form-1120-s/"
                    sx={{ color: '#0202ff' }}
                  >
                    Form 1120-S
                  </Link>
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="whyschk1"
                >
                  Why Schedule K-1 Matters
                </Typography>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Pass-Through Taxation
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Ensures income and deductions “pass through” from the S
                  corporation to shareholders without being taxed twice.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  IRS Compliance
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Accurate K-1 reporting prevents mismatches between corporate
                  and shareholder returns.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Shareholder Transparency
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Each shareholder can see exactly how much income, loss, or
                  credit they must report on their individual tax return.
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Accurate Financial Reporting
                </Typography>
                <Typography variant="body1" sx={{ mb: 4 }}>
                  Helps the corporation reconcile Schedule K totals with
                  Schedule K-1 distributions for all shareholders.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="whomust"
                >
                  Who Must File Schedule K-1?
                </Typography>

                <Typography variant="body1" sx={{ mb: 1 }}>
                  Every <span style={{ fontWeight: 600 }}>S corporation </span>{' '}
                  that files{' '}
                  <Link
                    href="/business-tax/efile-irs-form-1120-s/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Form 1120-S
                  </Link>{' '}
                  must also prepare a{' '}
                  <Link
                    href="https://www.irs.gov/pub/irs-pdf/f1120ssk.pdf"
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    Schedule K-1
                  </Link>{' '}
                  for each shareholder.
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  You must issue Schedule K-1 if:{' '}
                </Typography>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>
                    Your business elected S corporation status with the IRS{' '}
                  </li>
                  <li>
                    The corporation had income, deductions, credits, or other
                    tax items during the tax year{' '}
                  </li>
                  <li>There are one or more shareholders during the year </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 3 }}>
                  Each shareholder receives a{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    separate Schedule K-1
                  </span>
                  , and the corporation must file all K-1s with the IRS along
                  with{' '}
                  <span style={{ fontWeight: 600 }}> 1120s form.</span>{' '}
                </Typography>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                  }}
                >
                  Information Included on Schedule K-1
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Section
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Details Reported
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Part I: Information About the Corporation
                          </TableCell>
                          <TableCell>
                            Name, EIN, address, and IRS filing details
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Part II: Information About the Shareholder
                          </TableCell>

                          <TableCell>
                            Name, address, ownership percentage, and type of
                            stock owned
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell sx={{ fontWeight: 600 }}>
                            Part III: Shareholder’s Share of Income, Deductions,
                            Credits, etc.
                          </TableCell>

                          <TableCell>
                            Share of ordinary income, rental income, capital
                            gains, credits, foreign transactions, and
                            deductions{' '}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="key"
                >
                  Key Relationship Between Schedules K & K-1
                </Typography>
                <Box component="ul" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Schedule K (Form 1120-S)
                    </span>{' '}
                    shows <span style={{ fontWeight: 600 }}>
                      total amounts
                    </span>{' '}
                    of income, deductions, and credits for the entire
                    corporation.{' '}
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}> Schedule K-1</span>{' '}
                    breaks down those totals into{' '}
                    <span style={{ fontWeight: 600 }}>
                      each shareholder’s share.
                    </span>
                  </li>
                </Box>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  In short, <span style={{ fontWeight: 600 }}>Schedule K</span>{' '}
                  = summary for the corporation, and
                  <span style={{ fontWeight: 600 }}> Schedule K-1</span> =
                  detailed allocation per shareholder.
                </Typography>
                <Typography variant="body1" sx={{ mb: 4 }}>
                  Learn more about the purpose of{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    Schedule K (Form 1120-S)
                  </span>
                </Typography>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="filing"
                >
                  Filing Deadlines
                </Typography>
                <Typography variant="body1" sx={{ mb: 1 }}>
                  Schedule K-1 must be issued to shareholders{' '}
                  <span style={{ fontWeight: 600 }}>and</span> filed with the
                  IRS along with{' '}
                  <span style={{ fontWeight: 600 }}>Form 1120-S.</span>{' '}
                </Typography>

                <Box component="div" sx={{ mb: 2 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Entity Type
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Main Return
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Filing Deadline (Tax Year 2024)
                          </TableCell>
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Extension Form
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>S Corporation </TableCell>
                          <TableCell>
                            {' '}
                            <Link
                              href="/business-tax/efile-irs-form-1120-s/"
                              sx={{ color: '#0202ff' }}
                            >
                              Form 1120-S
                            </Link>{' '}
                          </TableCell>
                          <TableCell>March 15, 2025</TableCell>
                          <TableCell>
                            <Link
                              href="/tax-extension/efile-irs-form-7004-business-tax-extension-online/"
                              sx={{ color: '#0202ff' }}
                            >
                              {' '}
                              Form 7004
                            </Link>
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
                <Typography variant="body1" sx={{ mb: 4 }}>
                  Learn how to extend your S corporation filing deadline using{' '}
                  <span style={{ fontWeight: 600 }}> Form 7004</span>
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="howto"
                >
                  How to Complete Schedule K-1 (Form 1120-S)
                </Typography>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                    scrollMarginTop: 83,
                  }}
                  id="part1"
                >
                  Part I: Information About the Corporation
                </Typography>

                <Typography variant="body1" sx={{ mb: 2 }}>
                  It provide the S corporation's identifying information. It
                  helps the IRS and shareholders identify the corporation that
                  issued Schedule K-1 and links the shareholder's allocated tax
                  items to the correct Form 1120-S return.
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-1120s-part1-img.webp" />
                  <source srcSet="/assets/images/schk1-1120s-part1-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-1120s-part1-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1120-S) Part I showing information about the S corporation"
                    width={479}
                    height={500}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Item A: Corporation's Employer Identification Number
                  (EIN){' '}
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the corporation's EIN exactly as assigned by the IRS.
                  This unique number identifies the S corporation for tax
                  reporting purposes.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Item B: Corporation's Name, Address, City, State, and ZIP Code
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the complete legal name and mailing address of the S
                  corporation. Ensure the information matches the corporation's
                  Form 1120-S filing.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Item C: IRS Center Where Corporation Filed Return
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the IRS service center where the corporation filed its
                  Form 1120-S tax return. This identifies the IRS office
                  processing the return.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Item D: Corporation's Total Number of Shares
                </Typography>
                <Typography variant="body1" sx={{ mb: 0 }}>
                  Enter the total number of shares outstanding for the S
                  corporation during the tax year. This information helps
                  determine each shareholder's ownership interest.
                </Typography>
                <Box component="ul" sx={{ mb: 3, '& li': { mb: 1.2 } }}>
                  <li>
                    <span style={{ fontWeight: 600 }}>
                      {' '}
                      Beginning of Tax Year:
                    </span>{' '}
                    Enter the first day of the corporation's tax year covered by
                    Schedule K-1.
                  </li>
                  <li>
                    <span style={{ fontWeight: 600 }}> End of Tax Year:</span>{' '}
                    Enter the last day of the corporation's tax year covered by
                    Schedule K-1. This identifies the reporting period for the
                    shareholder's allocated tax items.
                  </li>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                    scrollMarginTop: 83,
                  }}
                  id="part2"
                >
                  Part II: Information About the Shareholder
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  It dentifies the shareholder receiving Schedule K-1 and
                  reports ownership details used to allocate the shareholder's
                  share of the S corporation's income, deductions, credits, and
                  other tax items.
                </Typography>
                <picture>
                  <source srcSet="/assets/images/schk1-1120s-part2-img.webp" />
                  <source srcSet="/assets/images/schk1-1120s-part2-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-1120s-part2-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1120-S) Part II showing information about the shareholder"
                    width={458}
                    height={522}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Item E: Shareholder's Identifying Number
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the shareholder's Taxpayer Identification Number (TIN),
                  such as a Social Security Number (SSN), Individual Taxpayer
                  Identification Number (ITIN), or Employer Identification
                  Number (EIN), as applicable.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Item F1: Shareholder's Name, Address, City, State, and ZIP
                  Code
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the shareholder's full legal name and current mailing
                  address. The information should match the shareholder's tax
                  records.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Item F2: If the Shareholder Is a Disregarded Entity, Trust,
                  Estate, or Nominee
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  If the shareholder is a disregarded entity, trust, estate,
                  nominee, or similar person, enter the name and TIN of the
                  individual or entity responsible for reporting the Schedule
                  K-1 information on the tax return.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Item F3: What Type of Entity Is This Shareholder?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the shareholder's entity type, such as an individual,
                  estate, trust, partnership, corporation, or other eligible
                  shareholder. This helps determine the applicable tax reporting
                  requirements.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Item G: Current Year Allocation Percentage
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the shareholder's percentage of stock ownership for the
                  current tax year. This percentage is generally used to
                  determine the shareholder's share of the corporation's tax
                  items.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Item H: Shareholder's Number of Shares
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the number of shares owned by the shareholder at the
                  beginning and end of the corporation's tax year. If ownership
                  changed during the year, report the applicable share amounts.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Item I: Loans From Shareholder
                </Typography>

                <Typography variant="body1" sx={{ mb: 3 }}>
                  Enter the outstanding balance of loans the shareholder made
                  directly to the corporation at the beginning and end of the
                  tax year. Report only bona fide loans and update the balances
                  to reflect any repayments or additional loans made during the
                  year.
                </Typography>

                <Typography
                  variant="h3"
                  sx={{
                    fontSize: '18px !important',
                    fontWeight: 600,
                    mb: 0.5,
                    mt: 1,
                    lineHeight: 1.5,
                    scrollMarginTop: 83,
                  }}
                  id="part3"
                >
                  Part III: Shareholder's Share of Current Year Income,
                  Deductions, Credits, and Other Items
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5 }}>
                  This reports each shareholder's share of the S corporation's
                  income, deductions, credits, and other tax items for the tax
                  year. Shareholders use this information to complete their
                  individual tax returns.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 1: Ordinary Business Income (Loss)
                </Typography>

                <picture>
                  <source srcSet="/assets/images/schk1-1120s-part3-line1-img.webp" />
                  <source srcSet="/assets/images/schk1-1120s-part3-line1-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-1120s-part3-line1-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1120-S) Line 1 showing ordinary business income (loss)"
                    width={293}
                    height={52}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the shareholder's share of ordinary business income or
                  loss from the S corporation. Report this amount on the
                  appropriate form or schedule, subject to any applicable
                  limitations.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 2: Net Rental Real Estate Income (Loss)
                </Typography>

                <picture>
                  <source srcSet="/assets/images/schk1-1120s-part3-line2-img.webp" />
                  <source srcSet="/assets/images/schk1-1120s-part3-line2-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-1120s-part3-line2-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1120-S) Line 2 showing net rental real estate income (loss)"
                    width={293}
                    height={53}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the shareholder's share of net rental real estate income
                  or loss. This amount may be subject to passive activity rules.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 3: Other Net Rental Income (Loss)
                </Typography>

                <picture>
                  <source srcSet="/assets/images/schk1-1120s-part3-line3-img.webp" />
                  <source srcSet="/assets/images/schk1-1120s-part3-line3-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-1120s-part3-line3-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1120-S) Line 3 showing other net rental income (loss)"
                    width={293}
                    height={53}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the shareholder's share of net income or loss from
                  rental activities other than real estate. Apply any applicable
                  passive activity limitations.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 4: Interest Income
                </Typography>

                <picture>
                  <source srcSet="/assets/images/schk1-1120s-part3-line4-img.webp" />
                  <source srcSet="/assets/images/schk1-1120s-part3-line4-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-1120s-part3-line4-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1120-S) Line 4 showing interest income"
                    width={292}
                    height={52}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the shareholder's share of taxable interest income
                  received by the S corporation during the tax year.{' '}
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 5a: Ordinary Dividends
                </Typography>

                <picture>
                  <source srcSet="/assets/images/schk1-1120s-part3-line5a-img.webp" />
                  <source srcSet="/assets/images/schk1-1120s-part3-line5a-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-1120s-part3-line5a-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1120-S) Line 5a showing ordinary dividends"
                    width={293}
                    height={52}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the shareholder's share of ordinary dividends received
                  by the S corporation.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 5b: Qualified Dividends
                </Typography>

                <picture>
                  <source srcSet="/assets/images/schk1-1120s-part3-line5b-img.webp" />
                  <source srcSet="/assets/images/schk1-1120s-part3-line5b-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-1120s-part3-line5b-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1120-S) Line 5b showing qualified dividends"
                    width={293}
                    height={52}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the shareholder's share of qualified dividends eligible
                  for the applicable tax rates.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 6: Royalties
                </Typography>

                <picture>
                  <source srcSet="/assets/images/schk1-1120s-part3-line6-img.webp" />
                  <source srcSet="/assets/images/schk1-1120s-part3-line6-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-1120s-part3-line6-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1120-S) Line 6 showing royalties"
                    width={293}
                    height={53}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the shareholder's share of royalty income received by
                  the S corporation during the tax year.
                </Typography>

                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 7: Net Short-Term Capital Gain (Loss)
                </Typography>

                <picture>
                  <source srcSet="/assets/images/schk1-1120s-part3-line7-img.webp" />
                  <source srcSet="/assets/images/schk1-1120s-part3-line7-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-1120s-part3-line7-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1120-S) Line 7 showing net short-term capital gain (loss)"
                    width={294}
                    height={53}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the shareholder's share of net short-term capital gain
                  or loss. Report it with other short-term capital transactions.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 8a: Net Long-Term Capital Gain (Loss)
                </Typography>

                <picture>
                  <source srcSet="/assets/images/schk1-1120s-part3-line8a-img.webp" />
                  <source srcSet="/assets/images/schk1-1120s-part3-line8a-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-1120s-part3-line8a-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1120-S) Line 8a showing net long-term capital gain (loss)"
                    width={294}
                    height={52}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the shareholder's share of net long-term capital gain or
                  loss. Report it with other long-term capital transactions.
                </Typography>

                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 8b: Collectibles (28%) Gain (Loss)
                </Typography>

                <picture>
                  <source srcSet="/assets/images/schk1-1120s-part3-line8b-img.webp" />
                  <source srcSet="/assets/images/schk1-1120s-part3-line8b-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-1120s-part3-line8b-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1120-S) Line 8b showing collectibles (28%) gain (loss)"
                    width={294}
                    height={52}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 1,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the shareholder's share of collectibles gain or loss
                  subject to the 28% capital gains tax rate.
                </Typography>

                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 8c: Unrecaptured Section 1250 Gain
                </Typography>

                <picture>
                  <source srcSet="/assets/images/schk1-1120s-part3-line8c-img.webp" />
                  <source srcSet="/assets/images/schk1-1120s-part3-line8c-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-1120s-part3-line8c-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1120-S) Line 8c showing unrecaptured Section 1250 gain"
                    width={293}
                    height={52}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the shareholder's share of unrecaptured section 1250
                  gain from the sale of depreciable real property.
                </Typography>

                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 9: Net Section 1231 Gain (Loss)
                </Typography>

                <picture>
                  <source srcSet="/assets/images/schk1-1120s-part3-line9-img.webp" />
                  <source srcSet="/assets/images/schk1-1120s-part3-line9-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-1120s-part3-line9-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1120-S) Line 9 showing net Section 1231 gain (loss)"
                    width={294}
                    height={52}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the shareholder's share of net section 1231 gain or loss
                  from business property transactions.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 10: Other Income (Loss)
                </Typography>

                <picture>
                  <source srcSet="/assets/images/schk1-1120s-part3-line10-img.webp" />
                  <source srcSet="/assets/images/schk1-1120s-part3-line10-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-1120s-part3-line10-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1120-S) Line 10 showing other income (loss)"
                    width={293}
                    height={257}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 1,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter other income or loss items not reported on Lines 1
                  through 9. Use the applicable code and statement if required.
                </Typography>

                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 11: Section 179 Deduction
                </Typography>

                <picture>
                  <source srcSet="/assets/images/schk1-1120s-part3-line11-img.webp" />
                  <source srcSet="/assets/images/schk1-1120s-part3-line11-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-1120s-part3-line11-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1120-S) Line 11 showing Section 179 deduction"
                    width={294}
                    height={53}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the shareholder's share of the Section 179 deduction.
                  This deduction may be limited based on the shareholder's
                  individual tax situation.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 12: Other Deductions
                </Typography>

                <picture>
                  <source srcSet="/assets/images/schk1-1120s-part3-line12-img.webp" />
                  <source srcSet="/assets/images/schk1-1120s-part3-line12-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-1120s-part3-line12-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1120-S) Line 12 showing other deductions"
                    width={293}
                    height={411}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the shareholder's share of deductible expenses not
                  reported elsewhere. Use the applicable code and attached
                  statement, if required.
                </Typography>

                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 13: Credits
                </Typography>

                <picture>
                  <source srcSet="/assets/images/schk1-1120s-part3-line13-img.webp" />
                  <source srcSet="/assets/images/schk1-1120s-part3-line13-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-1120s-part3-line13-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1120-S) Line 13 showing credits"
                    width={278}
                    height={257}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the shareholder's share of tax credits passed through by
                  the S corporation. Report each credit using the applicable
                  code.
                </Typography>

                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 14: Schedule K-3 Is Attached, If Checked
                </Typography>

                <picture>
                  <source srcSet="/assets/images/schk1-1120s-part3-line14-img.webp" />
                  <source srcSet="/assets/images/schk1-1120s-part3-line14-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-1120s-part3-line14-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1120-S) Line 14: Schedule K-3 attachment checkbox"
                    width={278}
                    height={55}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Check this box if{' '}
                  <span style={{ fontWeight: 600 }}> Schedule K-3</span> is
                  attached to report the shareholder's international tax
                  information.
                </Typography>

                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 15: Alternative Minimum Tax (AMT) Items
                </Typography>

                <picture>
                  <source srcSet="/assets/images/schk1-1120s-part3-line15-img.webp" />
                  <source srcSet="/assets/images/schk1-1120s-part3-line15-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-1120s-part3-line15-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1120-S) Line 15 showing Alternative Minimum Tax (AMT) item"
                    width={278}
                    height={258}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter the shareholder's share of AMT-related items. Use the
                  applicable codes and statements to report these amounts.
                </Typography>
                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 16: Items Affecting Shareholder Basis
                </Typography>

                <picture>
                  <source srcSet="/assets/images/schk1-1120s-part3-line16-img.webp" />
                  <source srcSet="/assets/images/schk1-1120s-part3-line16-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-1120s-part3-line16-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1120-S) Line 16 showing items affecting shareholder basis"
                    width={278}
                    height={256}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter items that increase or decrease the shareholder's stock
                  or debt basis. Report each item using the applicable code.
                </Typography>

                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 17. Other Information
                </Typography>

                <picture>
                  <source srcSet="/assets/images/schk1-1120s-part3-line17-img.webp" />
                  <source srcSet="/assets/images/schk1-1120s-part3-line17-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-1120s-part3-line17-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1120-S) Line 17 showing other information"
                    width={278}
                    height={514}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Enter additional tax information not reported elsewhere on
                  Schedule K-1. Include the applicable code and any required
                  statement.
                </Typography>

                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 18. More Than One Activity for At-Risk Purpose
                </Typography>

                <picture>
                  <source srcSet="/assets/images/schk1-1120s-part3-line18-img.webp" />
                  <source srcSet="/assets/images/schk1-1120s-part3-line18-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-1120s-part3-line18-img.png"
                    loading="lazy"
                    alt="Schedule K-1 (Form 1120-S) Line 18 showing more than one activity for at-risk purpose"
                    width={571}
                    height={28}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Check out this box if the shareholder has more than one
                  at-risk activity. See the attached statement for activity
                  details.
                </Typography>

                <Typography variant="body1" sx={{ mb: 0.5, fontWeight: 600 }}>
                  Line 19. More Than One Activity for Passive Activity Purposes
                </Typography>

                <picture>
                  <source srcSet="/assets/images/schk1-1120s-part3-line19-img.webp" />
                  <source srcSet="/assets/images/schk1-1120s-part3-line19-img.png" />
                  <Box
                    component="img"
                    src="/assets/images/schk1-1120s-part3-line19-img.png"
                    loading="lazy"
                    alt=" Schedule K-1 (Form 1120-S) Line 19 showing more than one activity for passive activity purposes"
                    width={569}
                    height={27}
                    className="img-responsive"
                    sx={{
                      border: '2px solid #333',
                      maxWidth: '100%',
                      mb: 2,
                    }}
                  />
                </picture>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Check this box if the shareholder has more than one passive
                  activity. See the attached statement for activity details.
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 0.5,
                    scrollMarginTop: 83,
                  }}
                  id="common"
                >
                  Common Mistakes to Avoid
                </Typography>
                <Box component="div" sx={{ mb: 4 }}>
                  <TableContainer sx={{ border: '1px solid #828282' }}>
                    <Table sx={{}} aria-label="Due Date Chart">
                      <TableHead>
                        <TableRow
                          sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                        >
                          <TableCell
                            sx={{ color: '#444', width: 300, fontWeight: 600 }}
                          >
                            Error
                          </TableCell>

                          <TableCell
                            sx={{ color: '#444', width: 200, fontWeight: 600 }}
                          >
                            Impact
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        <TableRow sx={{}}>
                          <TableCell>
                            Reporting shareholder shares that don’t match
                            ownership percentages
                          </TableCell>
                          <TableCell>IRS mismatches and notices</TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Forgetting to include shareholder basis adjustments
                          </TableCell>
                          <TableCell>Incorrect taxable income</TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>
                            Failing to reconcile Schedule K totals with all K-1s
                          </TableCell>
                          <TableCell>Inaccurate corporate reporting </TableCell>
                        </TableRow>
                        <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                          <TableCell>
                            Late distribution of Schedule K-1 to shareholders
                          </TableCell>
                          <TableCell>
                            Shareholders miss tax filing deadlines{' '}
                          </TableCell>
                        </TableRow>
                        <TableRow sx={{}}>
                          <TableCell>
                            Not filing K-1 copies with the IRS
                          </TableCell>
                          <TableCell>
                            Incomplete 1120-S filing and penalties{' '}
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 22, sm: 20, xs: 18 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="best"
                >
                  Best Practices for Compliance
                </Typography>

                <Box component="ul" sx={{ '& li': { mb: 1.5 }, mb: 4 }}>
                  <li>
                    Keep accurate records of shareholder ownership and
                    contributions.
                  </li>
                  <li>
                    Verify that{' '}
                    <span style={{ fontWeight: 600 }}>Schedule K</span> totals
                    match the sum of all{' '}
                    <span style={{ fontWeight: 600 }}>Schedule K-1s</span>.
                  </li>
                  <li>
                    Provide K-1s to shareholders well before their individual
                    filing deadlines.
                  </li>
                  <li>
                    Maintain separate K-1s for current-year and prior-year
                    ownership changes.{' '}
                  </li>
                  <li>
                    Use{' '}
                    <span style={{ fontWeight: 600 }}>
                      TaxZerone’s guided e-filing
                    </span>{' '}
                    to automatically generate and attach all Schedule K-1s when
                    filing <span style={{ fontWeight: 600 }}>Form 1120-S.</span>
                  </li>
                </Box>

                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 26, md: 20, sm: 18, xs: 16 },
                    fontWeight: 600,
                    mb: 2,
                    scrollMarginTop: 83,
                  }}
                  id="faqs"
                >
                  Frequently Asked Questions (FAQs)
                </Typography>

                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  1. What is the purpose of Schedule K-1 (Form 1120-S)?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  It reports each shareholder’s share of the S corporation’s
                  income, deductions, credits, and other tax items.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  2. Who receives a Schedule K-1?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Every shareholder in an S corporation receives one, reflecting
                  their share of the corporation’s annual financial activity.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  3. When are Schedule K-1s due?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2, '& li': { mb: 1.2 } }}>
                  They must be filed with the IRS and provided to shareholders
                  by the due date of{' '}
                  <span style={{ fontWeight: 600 }}> Form 1120-S</span> (March
                  15, 2025).
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  4. Can Schedule K-1 be e-filed?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Yes. When you e-file{' '}
                  <span style={{ fontWeight: 600 }}> Form 1120-S</span> through
                  TaxZerone, all shareholder K-1s are automatically generated
                  and transmitted to the IRS.
                </Typography>
                <Typography variant="body1" sx={{ fontWeight: 600, mb: 1 }}>
                  5. What if a shareholder doesn’t receive their K-1 on time?
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  The S corporation may face penalties, and shareholders could
                  need to file for an extension using{' '}
                  <span style={{ fontWeight: 600 }}>Form 4868</span> or{' '}
                  <span style={{ fontWeight: 600 }}>Form 7004.</span>
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Container maxWidth="lg" sx={{ mb: 5, my: { xs: 6, sm: 6, md: 6 } }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={{ xs: 2, md: 5 }}
        >
          <Box
            sx={{
              width: '100%',
              textAlign: 'center',
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 2,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              E-File Your Form 1120-S with Schedule K-1 Using TaxZerone
            </Typography>

            <Typography
              variant="h3"
              sx={{
                fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                fontWeight: 400,
                color: '#333333',
                mb: 3,
              }}
            >
              Ensure each shareholder’s income, deductions, and credits are
              accurately reported and IRS-compliant.
            </Typography>

            <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
              <Button
                variant="contained"
                sx={{
                  mt: 1,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-primary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=schk1`}
              >
                Start Filing Now
              </Button>
            </Box>
          </Box>
        </Stack>
      </Container>
    </AppLayout>
  );
};

export default Form1120SchK1;
